module.exports = __webpack_public_path__ + "img/166.718a4a22.jpg";